<template>
    <div>
      <table id="datatable" class="table-hover table-striped table-bordered">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Fecha de pago</th>
            <th>Banco</th>
            <th>Nro. de operación</th>
            <th>Monto</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in dataUsers" :key="user.id">
            <td>{{ user.name }}</td>
            <td>{{ moment(user.date).format('DD/MM/YYYY hh:mm A') }}</td>
            <td>{{ user.bank }}</td>
            <td>{{ user.reference_code }}</td>
            <td>S/. {{ user.amount }}</td>
            <td><button class="btn btn-info" @click="modalUser(user)">observar</button></td>
          </tr>
        </tbody>
      </table>
  
      <!-- Modal View Request -->
      <div class="modal fade" id="modalViewRequest" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Informacion del Usuario</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <p><strong>Usuario: </strong> {{userInfo.name}}</p>
              </div>
              <div class="form-group">
                <p><strong>Correo: </strong> {{userInfo.email}}</p>
              </div>
              <div class="form-group">
                <p><strong>Teléfono: </strong> {{userInfo.phone}}</p>
              </div>
              <div class="form-group">
                <p><strong>Tipo de documento: </strong> {{userInfo.doc_name}}</p>
              </div>
              <div class="form-group">
                <p><strong>Número de documento: </strong> {{userInfo.number_doc}}</p>
              </div>
            </div>
            <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="modalReject()"
                >
                  Denegar
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="approveDeny()"
                >
                  Aprobar
                </button>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Modal Reject Afiliation -->
      <custom-modal v-bind:id="'viewRejectAfiliation'">
        <template #title>¿Seguro que desea rechazar la compra?</template>
        <template #body>
          <div class="table-responsive">
            <table class="table table-striped">
              <tbody>
                <p>Denegar el pago de {{paymentSelected.name}}</p>
                <div class="form-group">
                  <textarea
                    name="mensaje"
                    required=""
                    class="form-control"
                    placeholder="Introduzca el motivo de rechazo del pago de esta afiliación"
                    v-model="justification"
                  ></textarea>
                </div>
              </tbody>
            </table>
          </div>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" @click="rejectDeny()">
            <span
              class="spinner-border spinner-border-sm text-danger"
              role="status"
              aria-hidden="true"
              v-if="loading"
            ></span>
            <span class="ml-25 align-middle"> Desautorizar </span>
          </button>
        </template>
      </custom-modal>
    </div>
  </template>
  <script>
  import api from '../../api/api';
  import ModalComponent from '../ModalComponent.vue';
  import language from '../../api/traduction_es';
  import moment from 'moment';
  
  export default {
    components: {
      'custom-modal': ModalComponent,
    },
    data() {
      return {
        initialLoading: true,
        dataUsers: [],
        dataUser: [],
        sponsor: Object,
        payments: [],
        typeDocuments: [],
        paymentMethod: [],
        moment: moment,
        justification: '',
        loading: false,
        userInfo: [],
        paymentSelected: [],
      };
    },
    mounted() {
      this.listPayments();
    },
    methods: {
      modalUser(user) {
        $('#modalViewRequest').modal('show');
        this.paymentSelected = user;
        axios.get(`/user/${user.user_id}/info`).then((r) => {
            this.userInfo = r.data;
        });
      },
      modalReject() {
        $('#modalViewRequest').modal('hide'); //cierra el modal
        $(`#viewRejectAfiliation`).modal('show'); // abre modal para añadir la razon de la negación
      },
      approveDeny() {
        this.loading = true;
        const form = {
            'payment_id': this.paymentSelected.payment_id
        };
        axios.patch(`/payments/product/approve`, form).then((r) => {
          if (r.status == 200) {
            $('#modalViewRequest').modal('hide');
            this.initialLoading = false;
            this.listPayments();
            this.$message.success('Petición aceptada');
          } else {
            this.$message.warning('Petición Rechazada!');
            $(`#viewRejectAfiliation`).modal('hide');
            this.loading = false;
            this.listPayments();
          }
        });
      },
      loadDataTable() {
        this.$nextTick(function () {
          $('#datatable').DataTable(language);
        });
      },
      async rejectDeny(){
        const form = {
            'payment_id': this.paymentSelected.payment_id,
            'justification': this.justification
        }
        axios.patch('/payments/product/reject', form).then((response) => {
            console.log(response);
            this.listPayments();
            $(`#viewRejectAfiliation`).modal('hide');
            this.justification = "";
        });
      },
      async listPayments() {
        this.initialLoading = true;
        await axios.get(`/payments/product/requests`).then((response) => {
          this.initialLoading = false;
          this.dataUsers = response.data;
          $('#datatable').DataTable().destroy();
          this.loadDataTable();
        });
      },
    },
  };
  </script>